import { ProtectedValue } from "./ProtectedValue";



export class Score {
    /**
     * Udalost vyvolana po zmene skore
     * Parametry:
     * - this: Score
     * - value: number
     */
    static readonly EVENT_SCORE_CHANGE = "score:change";

    /**
     * Udalost vyvolana pri zmene nasobice skore
     * Parametry:
     * - this: Score
     * - value: number
     */
    static readonly EVENT_MUTLI_CHANGE = "score:multiChange";

    /**
     * Spravce udalosti
     */
    get event(): pc.EventHandler { return this._events; }
    private _events: pc.EventHandler;

    /**
     * Aktualni hodnota skore
     */
    get value(): number { return this._value.value; }
    set value(val: number) { this.setValue(val); }
    private _value: ProtectedValue;

    /**
     * Nasobic skore
     */
    get multiplier(): number { return this._multiplier.value; }
    set multiplier(value: number) {
        if (value > this._maxMultiplier)
            value = this._maxMultiplier;

        if (value != this.multiplier) {
            this._multiplier.value = value;

            if (this._events && (this._flags & Score.FLAG_EMIT_MULTI_CHANGE) != 0)
                this._events.fire(Score.EVENT_MUTLI_CHANGE, this, value);
        }
    }
    private _multiplier: ProtectedValue;

    /**
     * (RO) Maximalni hodnota nasobice
     */
    get maxMultiplier(): number { return this._maxMultiplier; }
    private _maxMultiplier: number;

    /**
     * Bude se vyvolavat udalost EVENT_SCORE_CHANGE
     */
    static readonly FLAG_EMIT_SCORE_CHANGE = 0x0001;

    /**
     * Bude se vyvolavat udalost EVENT_MUTLI_CHANGE
     */
    static readonly FLAG_EMIT_MULTI_CHANGE = 0x0002;

    private _flags: number;

    //-------------------------------------------------------------------------
    /**
     * @param maxMultiplier Max hodnota nasobice (def = 1)
     * @param events Spravce udalosti, pres ktery se budou vyvolavat udalosti skore. Pokud nezadano, tak se udalosti nebudou vyvolavat)
     * @param flags
     */
    //-------------------------------------------------------------------------
    constructor(maxMultiplier: number = 1, events?: pc.EventHandler, flags: number = Score.FLAG_EMIT_MULTI_CHANGE | Score.FLAG_EMIT_SCORE_CHANGE) {
        this._maxMultiplier = maxMultiplier;
        this._events = events;
        this._flags = flags;

        this._value = new ProtectedValue();
        this._multiplier = new ProtectedValue();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(score: number = 0, multiplier: number = 1): void {
        this.setValue(score);
        this.multiplier = multiplier;
    }

    //-------------------------------------------------------------------------
    /**
     * Navyseni hodnoty skore
     * @param value Hodnota, o kterou se ma skore navysit (bude vynasobena aktualni hodnotou nasobice)
     * @returns Vraci hodnotu, o kterou se skore skutecne zvedlo (v zavislosti na multiplieru)
     */
    //-------------------------------------------------------------------------
    incScore(value: number): number {
        if (value != 0)
            this.setValue(this.value + (value *= this._multiplier.value));

        return value;
    }

    //-------------------------------------------------------------------------
    /**
     * Snizeni skore. Nebere se v potaz multiplier
     * @param value Hodnota, ktera se ma odecist (kladna)
     */
    //-------------------------------------------------------------------------
    decScore(value: number): void {
        this.setValue(this.value - value);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private setValue(value: number): void {
        if (value < 0)
            value = 0;

        if (value != this._value.value) {
            this._value.value = value;

            if (this._events && (this._flags & Score.FLAG_EMIT_SCORE_CHANGE) != 0)
                this._events.fire(Score.EVENT_SCORE_CHANGE, this, value);
        }
    }
}